// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"c76f2495","232":"38857b43","237":"56bd42de","357":"ec3ccf36","457":"02aaf856","526":"89f4cbae","653":"04148053","753":"7033399d","854":"5523dc82","872":"f6e64d7e"}[chunkId] + ".chunk.js";
};